import { render, staticRenderFns } from "./MedicalAlertForm.vue?vue&type=template&id=6ec6f7b7&scoped=true&"
import script from "./MedicalAlertForm.vue?vue&type=script&lang=js&"
export * from "./MedicalAlertForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec6f7b7",
  null
  
)

export default component.exports